<template>
  <v-layout align-center justify-center row wrap>
    <div>
      <v-pagination v-model="page" :length="length" :total-visible="totalVisible"/>
    </div>
    <div>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on" small>
            {{ $t("items_per_page") }} {{ pageSize ? pageSize : $t("show_all") }}
            <v-icon>arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="(item, index) in pageSizes"
            :key="index"
            @click="onChangePageSize(index)"
          >
            <v-list-tile-title>{{ item ? item : $t("show_all") }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </div>
  </v-layout>
</template>

<i18n>
    {
        "de": {
            "show_all" : "Alle",
            "show_all_confirm": "Das darstellen aller Einträge kann sehr lange dauern.\nSollen alle Einträge angezeigt werden?",
            "items_per_page" : "Einträge pro Seite:"
        },
        "en":{
            "show_all" : "all",
            "show_all_confirm": "To display all items can take a long time.\nShould all items be displayed?",
            "items_per_page" : "Items per page:"
        }
    }
</i18n>
<script>
export default {
  data() {
    return {
      selectedPageSize: 0,
      page: 1
    };
  },
  watch: {
    page() {
      this.emit_change();
    }
  },
  props: {
    pageSizes: {
      type: Array,
      default: () => [25, 50, 100, null]
    },
    length: {
      type: Number,
      required: true
    },
    totalVisible: {
      type: Number,
      default: 7
    }
  },
  computed: {
    pageSize() {
      return this.pageSizes[this.selectedPageSize];
    }
  },
  methods: {
    onChangePageSize(value) {
      if (
        Number.isInteger(this.pageSizes[value]) ||
        confirm(this.$t("show_all_confirm"))
      ) {
        this.selectedPageSize = value;
        this.emit_change();
      }
    },
    emit_change() {
      this.$emit("change", { page: this.page, pageSize: this.pageSize });
    }
  }
};
</script>
